import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  height: fit-content;
  padding-bottom: 1.2rem;
  margin-top: 1.45rem;
  border-radius: 0.73rem;
`

export const HeaderDiv = styled.div`
  display: flex;
  margin-top: 1rem;
  margin-left: 1.1rem;
  margin-right: 1.1rem;
  min-height: 2rem;
  justify-content: space-between;
  align-items: center;
`

export const HeaderText = styled.h3`
  margin-top: 0;
  margin-bottom: 0;
  font-weight: 700;
  font-size: clamp(1rem, calc(1rem + 0.2vw) , 2.7rem);
  font-family: 'Inter', sans-serif;
`
